<div
  class="flex h-[56px] w-full items-center justify-between border-b border-proffeo-border px-2 hover:bg-proffeo-surface-muted transition-default"
>
  <div class="flex w-full items-center gap-1 px-2">
    <div class="flex w-full items-center gap-2">
      <div class="flex w-full items-center justify-between gap-3">
        <div class="flex items-center gap-3">
          <mat-icon
            (click)="toggleChildren()"
            [fontIcon]="childrenVisible() ? 'keyboard_arrow_up' : 'keyboard_arrow_down'"
            [ngClass]="{
              'opacity-0 pointer-events-none': $safeNavigationMigration(alreadySelectedGroups()?.length) <= 0
            }"
            class="cursor-pointer"
          />
          <mat-icon
            fontIcon="domain"
            class="h-[30px] w-[30px] icon-xl icon-muted"
          />
          <p class="max-sm:max-w-30 truncate">
            {{ company().name }}
          </p>
        </div>
        <proffeo-ui-button
          (clicked)="selectGroups()"
          fontIcon="add"
          text="project-participants.modals.select-groups"
        ></proffeo-ui-button>
      </div>
    </div>
  </div>
</div>

@if (childrenVisible() && alreadySelectedGroups()?.length) {
  <div class="flex flex-col">
    @for (group of alreadySelectedGroups(); track group.id) {
      <proffeo-project-participant-item
        [group]="group"
        [participants]="participantsForGroup(group)"
      />
    }
  </div>
}
